export enum EmbedMode {
  FULL_WINDOW = 'FULL_WINDOW',
  SIZED_CONTAINER = 'SIZED_CONTAINER',
  IN_LINE = 'IN_LINE',
  LIGHT_BOX = 'LIGHT_BOX',
}

export enum DefaultViewMode {
  FIT_PAGE = 'FIT_PAGE',
  FIT_WIDTH = 'FIT_WIDTH',
  TWO_COLUMN = 'TWO_COLUMN',
  TWO_COLUMN_FIT_PAGE = 'TWO_COLUMN_FIT_PAGE',
}

export interface PreviewFileOptions {
  embedMode?: EmbedMode;
  showAnnotationTools?: boolean;
  showDownloadPDF?: boolean;
  showPrintPDF?: boolean;
  showThumbnails?: boolean;
  showBookmarks?: boolean;
  showZoomControl?: boolean;
  defaultViewMode?: DefaultViewMode;
  enableLinearization?: boolean;
  enableFormFilling?: boolean;
  enableAnnotationAPIs?: boolean;
  includePDFAnnotations?: boolean;
}

export interface PreviewFileArgs {
  content: {
    location: { url: string };
  };
  metaData: {
    fileName: string;
  };
}

export interface AdobeDC {
  AdobeDC?: {
    View: new (config: { clientId: string; divId: string }) => {
      previewFile: (
        args: PreviewFileArgs,
        options?: PreviewFileOptions,
      ) => void;
    };
  };
}
